<script setup>
import { useI18n } from 'vue-i18n';
import axios from 'axios';
import { onMounted, ref } from 'vue';
const { locale } = useI18n();
const whychoose = ref({});

async function getWhyChoose() {
    try {
        const res = await axios.get('/why-choose-data');
        whychoose.value = res.data || {};
    } catch (error) {
        console.error('Error fetching :', error);
    }
}

onMounted(() => {
    getWhyChoose();
})

</script>
<template>
    <div class="lg:w-1/2 w-full wow animate__animated animate__fadeInLeft">
        <div class="flex relative pb-12" v-for="(item,index) in whychoose" :key="index">
            <div class="h-full w-9 absolute inset-0 flex items-center justify-center">
                <div class="h-full border-dashed border border-primary" :class="{'border-none': index === whychoose.length - 1}"></div>
            </div>
            <div
                class="flex-shrink-0 w-9 h-9 rounded-full bg-primary inline-flex items-center justify-center text-gray-700 text-lg z-10">
                {{index+1}}
            </div>
            <div class="flex-grow pl-4 pt-2">
                <p class="text-black text-lg font-medium">{{ locale === 'BN' ? item?.bn_title : item?.title }}</p>
            </div>
        </div>
    </div>
</template>
<style scoped></style>
